/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DevCodeIcon24Solid = forwardRef('DevCodeIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M16.017 3.395a1.375 1.375 0 0 0-2.634-.79l-5.4 18a1.375 1.375 0 1 0 2.634.79l5.4-18Z" }),
        React.createElement("path", { d: "M6.972 5.778a1.375 1.375 0 0 1 0 1.944L2.995 11.7a.425.425 0 0 0 0 .6l3.977 3.978a1.375 1.375 0 1 1-1.944 1.944L1.05 14.245a3.175 3.175 0 0 1 0-4.49l3.977-3.977a1.375 1.375 0 0 1 1.944 0Z" }),
        React.createElement("path", { d: "M17.028 5.778a1.375 1.375 0 0 1 1.944 0l3.977 3.977a3.175 3.175 0 0 1 0 4.49l-3.977 3.977a1.375 1.375 0 0 1-1.944-1.944l3.977-3.977a.425.425 0 0 0 0-.601l-3.977-3.978a1.375 1.375 0 0 1 0-1.944Z" })));
});
